export const AdminLeadPoolPermissions = {
  AdminLeadPoolPermissions: {
    permissionsId: "44184cc4-0fc6-49fb-5dc8-08dc7403ebc2",
    permissionsName: "Leads Pool",
    description: null,
    componentsId: null,
    components: null
  },
};
